<template>
  <!-- This cloud search is specific for SALES INSTRUCTIONS -->
  <v-autocomplete
    @update:search-input="isTyping = true"
    @input="chosenProperties"
    @click:clear="clearSearch"
    v-model="model"
    :search-input.sync="searchQuery"
    label="Search Tenancy"
    :items="searchResult"
    item-text="Subject"
    :item-value="itemValue"
    :loading="loading"
    :hide-no-data="hideNoData"
    :no-data-text="noDataText"
    prepend-inner-icon="mdi-home"
    :menu-props="{ offsetY: true }"
    clearable
    return-object
    hint="At least 5 characters"
    :color="color"
    outlined
    dense
  ></v-autocomplete>
</template>

<script>
import debounce from "lodash/debounce";
import { API } from '@aws-amplify/api';

export default {
  name: "search-letting-properties",
  props: {
    color: {
      type: String,
      default: "blue",
    },
  },
  data() {
    return {
      model: null,
      searchQuery: null,
      isTyping: false,
      searchResult: [],
      loading: false,
      hideNoData: true,
      noDataText: "",
    };
  },
  watch: {
    searchQuery: debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value && this.searchQuery && this.searchQuery.length > 5) {
        this.searchProperty(this.searchQuery);
        this.loading = true;
      }
    },
  },
  computed: {},
  methods: {
    itemValue(item) {
      if (item) {
        return item.OID;
      }
      return "";
    },
    clearSearch() {
      this.isTyping = false;
      this.searchQuery = "";
    },
    chosenProperties() {
      const selectedProperty = this.model;
      this.$emit("selectedLettingProperty", selectedProperty);
      this.model = null;
    },
    async searchProperty(query) {
      try {
        // Map to GET /corporate/agentapp/:shortName/:clientName/search/lettingsproperties
        const { data } = await API.get('negAppRestApi', '/proxy/get', {
          headers: {
            token: this.$store.state.user.LoginToken
          },
          queryStringParameters: {
            endpoint: `/${this.$store.state.user.ClientName}/search/lettingsproperties`,
            address: query
          }
        });

        if (data.Count > 0) {
          this.searchResult = data.Data;
          this.loading = false;
          // console.log('Sales instruction search OK')
        } else {
          this.hideNoData = false;
          this.loading = false;
          this.noDataText = "No data found with this name";
          // console.log('no sales instruction with this name...')
        }
      } catch (error) {
        this.hideNoData = false;
        this.loading = false;
        this.noDataText = "An error has occured in the system. Try again.";
      }
    }
  },
};
</script>